import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { pt } from 'vuetify/locale';
import 'vuetify/styles';

export default createVuetify({
    components,
    directives,
    locale: {
        locale: 'pt',
        messages: {pt}
    }
});
